<template v-slot:default="">
        <b-sidebar backdrop :id="'PackageInfo'"
             right
            bg-variant="grey" :shadow="true">
            <div class="tab-pane active p-20">
                <img :src="imagePath" class="w-100" />
            </div>
        </b-sidebar>
</template>

<script>
export default{
    props:['LangId','CurPackage'],
    computed:{
        imagePath(){
            if(!this.CurPackage){
                return ""
            }
            var langPath = this.LangId == 1252 ? "en" : "cn";
            return 'https://cdn.adsalecdn.com/EMP/Backend/Images/Dashboard/' + this.CurPackage  + '_' + langPath + '.jpg'
        }
    }
}
</script>